import { Brand } from './brands';
import { Site } from './sites';

export const SitesToBrands: Record<Site, Brand | undefined> = {
  [Site.A523]: Brand.SNAPCHAT,
  [Site.AR]: Brand.SNAPCHAT,
  [Site.CAREERS]: Brand.SNAPCHAT,
  [Site.CITIZEN]: Brand.SNAPCHAT,
  [Site.CREATORS]: Brand.SNAPCHAT,
  [Site.DIVERSITY]: Brand.SNAPCHAT,
  [Site.EDUCATORS]: Brand.SNAPCHAT,
  [Site.ENG_BLOG]: Brand.SNAP,
  [Site.EXPERIENCE]: Brand.SNAPCHAT,
  [Site.FOR_BUSINESS]: Brand.SNAPCHAT,
  [Site.NEWSROOM]: Brand.SNAPCHAT,
  [Site.PARENTS]: Brand.SNAPCHAT,
  [Site.SANDBOX]: Brand.SNAPCHAT,
  [Site.TRUST]: Brand.SNAPCHAT,
  [Site.AVALON]: Brand.SPECTACLES,
  [Site.SNAP]: Brand.SNAP,
  [Site.ARCADIA]: undefined,
  [Site.CHEERIOS]: undefined,
  [Site.STINSON]: undefined,
};
